<template>
  <div class="row m-0 input_height">
    <div class="col-auto p-0 h-100">
      <div class="row m-0 align-items-center h-100 cursor">
        <div class="col-auto p-0 px-md-0" @click="toggleOpen">
          <ios-search-icon />
        </div>
        <transition name="fade" mode="out-in">
          <div class="m-0 abs d-md-none" v-if="isOpen">
            <div class="form-group m-0">
              <input
                type="text"
                name="search"
                id="search"
                class="form-control"
                placeholder="Search"
                v-model="search"
                @input="doSearch"
                ref="search"
              />
            </div>
          </div>
        </transition>
        <div class="col px-1 pb-2 d-none d-md-block">
          <transition name="fade" mode="out-in">
            <div class="form-group m-0" v-if="isOpen">
              <input
                type="text"
                name="search"
                id="search"
                class="form-control"
                placeholder="Search"
                v-model="search"
                @input="doSearch"
                ref="search"
              />
            </div>
            <div v-else @click="toggleOpen">Search</div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isOpen: false,
      search: ''
    }
  },
  methods: {
    toggleOpen () {
      this.isOpen = !this.isOpen
      if (this.isOpen === true) {
        this.$nextTick(() => {
          this.$refs.search.focus()
        })
      }
    },
    doSearch () {
      this.$emit('search', this.search)
    }
  }
}
</script>

<style scoped>
  .input_height {
    height: 46px;
  }
  .abs {
    position: absolute;
    top: 0;
    left: 100%;
    height: max-content;
    padding: 0;
    width: max-content;
    background-color: var(--light-color);
    z-index: 2;
  }
  .dark-mode .abs {
    background-color: var(--dark-color-off);
  }
</style>
